import React from "react";
import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import { SubscribeNowTemplate } from "./subscribe-now";
import { SubscribeToNewsletters } from "./subscribe-to-newsletters";
import { TwoRowsFourStories } from "./two-rows-four-stories";
import { ThreeColThreeCollectionStories } from "./three-col-three-collection";
import { FourStoriesComponent } from "./four-stories-component";
import TwocollectionsWithSevenStories from "../collection-templates/twocollections-with-seven-stories";
import OneRowThreeCol from "../collection-templates/one-row-three-col";
import ThreeCollectionsWithPoll from "./three-collection-with-poll";
import { NlPodcastRow } from "./nl-podcast";
import { ComicsRow } from "./comics";
import { FourStoriesWithCampaign } from "./four-stories-with-campaign";
import { UdayFoundationBanner } from "./uday-foundation";

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={token => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  return wrappedComponent;
}

export default {
  SubscribeToNewsletters: wrapEager(wrapCollectionLayout(SubscribeToNewsletters)),
  FourStoriesComponent: wrapEager(wrapCollectionLayout(FourStoriesComponent)),
  TwocollectionsWithSevenStories: wrapEager(wrapCollectionLayout(TwocollectionsWithSevenStories)),
  TwoRowsFourStories: wrapEager(wrapCollectionLayout(TwoRowsFourStories)),
  SubscribeNowTemplate: wrapEager(wrapCollectionLayout(SubscribeNowTemplate)),
  OneRowThreeCol: wrapEager(wrapCollectionLayout(OneRowThreeCol)),
  ThreeColThreeCollectionStories: wrapEager(wrapCollectionLayout(ThreeColThreeCollectionStories)),
  ThreeCollectionsWithPoll: wrapEager(wrapCollectionLayout(ThreeCollectionsWithPoll)),
  NlPodcastRow: wrapEager(wrapCollectionLayout(NlPodcastRow)),
  ComicsRow: wrapEager(wrapCollectionLayout(ComicsRow)),
  FourStoriesWithCampaign: wrapEager(wrapCollectionLayout(FourStoriesWithCampaign)),
  UdayFoundationBanner: wrapEager(wrapCollectionLayout(UdayFoundationBanner)),
  defaultTemplate: wrapCollectionLayout(OneRowThreeCol)
};
